import { client } from "../../../ajax";
import {
  sendingRequest,
  receivedResponse,
  createAction
} from "../../../redux_util";
import formatError from "../../../formatErrors";

export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const fetchProfileSuccess = createAction(FETCH_PROFILE_SUCCESS, "data");
export const fetchProfile = () => {
  return dispatch => {
    dispatch(sendingRequest("fetchProfile"));
    return client
      .get("profile")
      .then(res => {
        dispatch(receivedResponse("fetchProfile"));
        return dispatch(fetchProfileSuccess(res.data));
      })
      .catch(err => {
        return dispatch(
          receivedResponse("fetchProfile", formatError(err), "ERROR")
        );
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/shared/redux/actions.js